import React from "react";
import {
  Button,
  Chip,
  Typography,
  createStyles,
  makeStyles,
} from "@material-ui/core";
import CardCommon from "../../card/CardCommon";
import { CustomTheme } from "../../../types/customTheme";

export interface VoidSummeryProps {
  locationSelectedList: any;
  handleOnClickText: any;
  locationSelectorListLength?: any;
  getDailySaleReportInfo?: any;
  filterData?: any;
  isBasedOnShift?: any;
  isShowButton?: any;
}

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    button: {
      borderRadius: "10px",
      height: "10px,",
      backgroundColor: theme.palette.custom.yellow.main,
      color: theme.palette.custom.yellow.contrastText,
      width: "100%",
      "&:hover": {
        backgroundColor: theme.palette.custom.yellow.dark,
      },
    },
    chipStyle: {
      backgroundColor: theme.palette.background.default,
      margin: "4px",
      "&&:focus": {
        backgroundColor: theme.palette.background.default,
      },
    },
    name: {
      fontWeight: "bold",
      paddingRight: "8px",
      color: theme.palette.custom.blue.contrastText,
    },
  }),
);

const LocationDetailsCard: React.FunctionComponent<VoidSummeryProps> = ({
  locationSelectedList,
  handleOnClickText,
  locationSelectorListLength,
  getDailySaleReportInfo,
  filterData,
  isBasedOnShift,
  isShowButton,
}) => {
  const classes = useStyles();
  return (
    <div style={{display: "flex", alignItems :"center"}}>
      <div>
        <CardCommon color={"blue"}>
          <div
            style={{
              margin: "4px 2px 4px 10px",
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <Typography className={classes.name}>
              {locationSelectedList.length > 1 ? "Locations: " : "Location: "}
            </Typography>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {locationSelectorListLength === locationSelectedList.length ? (
                <Chip
                  label={"All Locations"}
                  className={classes.chipStyle}
                  onClick={() => handleOnClickText()}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                locationSelectedList &&
                locationSelectedList.map((locationDetails: any) => (
                  <Chip
                    label={locationDetails.label}
                    className={classes.chipStyle}
                    onClick={() => handleOnClickText()}
                    style={{ cursor: "pointer" }}
                  />
                ))
              )}
            </div>
          </div>
        </CardCommon>
      </div>
      {isShowButton && (
        <div>
          {
            <div style={{ marginLeft: "12px" }}>
              <Button
              style={{minWidth: "160px", height:"48px"}}
                onClick={() =>
                  getDailySaleReportInfo(filterData, isBasedOnShift)
                }
                className={classes.button}
              >
                Generate Report
              </Button>
            </div>
          }
        </div>
      )}
    </div>
  );
};

export default LocationDetailsCard;
